export default {
	 baseUrl: 'https://qy3d.cn',
}